/** @jsxRuntime classic */
/** @jsx jsx */
import {jsx, css} from '@emotion/core'
import {Link, RouteComponentProps} from '@reach/router'
import { rgba } from 'polished'
import {MdChevronRight} from 'react-icons/md'
import {Box} from 'reoil'
import Navigation from '../components/Navigation'
import TabNav from '../components/TabNav'
import {MAX_WIDTH} from '../constants/media'
import {useContentValue} from '../store/contentState'
import {useThemeValue} from '../store/themeState'

const HelpPage: React.FC<RouteComponentProps> = () => {
  const theme = useThemeValue()
  const content = useContentValue()

  const helpContent = content.find(item => item.type === 'help')?.content

  return (
    <Box className='HelpPage' stretch pb={6}>
      <TabNav />
      <Navigation title='招聘帮助' />

      <Box
        className='content'
        stretch
        bg='white'
        p={3}
        css={css`
          h3 {
            margin-bottom: 20px;
          }

          .FAQ-title {
            color: ${theme.colors.primary};
            margin-bottom: 12px;
            font-weight: bold;
          }

          .FAQ-answer {
            color: ${theme.colors.text.body2};
            margin-bottom: 24px;
            line-height: 1.4;
          }

          img {
            box-shadow: ${theme.shadows.card};
            border-radius: 2px;
          }
        `}>
        {/* <h3>南方报业2021校园招聘FAQ</h3> */}

        <Box maxWidth={MAX_WIDTH} mx='auto'>
          <p dangerouslySetInnerHTML={{__html: helpContent || ''}}></p>

          <Link
            to='/user'
            css={css`
              text-decoration: none;
              color: inherit;
              display: flex;
              align-items: center;
              /* margin: 0 auto; */
              margin-left: auto;
              background-color: ${rgba(theme.colors.primary, .1)};
              color: ${theme.colors.primary};
              padding: 10px 20px;
              border-radius: 4px;
            `}>
            个人中心 <MdChevronRight />
          </Link>
        </Box>

        {/* <Box {...responseBoxProp}>
          <h3>南方报业2021校园招聘FAQ</h3>

          <h4>1、请问在哪里可以查看到此次校园招聘的最新动态？</h4>
          <p>最新动态信息请关注官方微信公众号（南方报业校园招聘）、南方+客户端南方号（南方报业招聘）、官方微信服务号（南方报业招聘）、新浪官方微博（@南方报业校园招聘），若有任何进展，将及时更新发布。</p>
          
          <h4>2、请问在哪里可以查看到此次校园招聘的最新动态？</h4>
          <p>最新动态信息请关注官方微信公众号（南方报业校园招聘）、南方+客户端南方号（南方报业招聘）、官方微信服务号（南方报业招聘）、新浪官方微博（@南方报业校园招聘），若有任何进展，将及时更新发布。</p>

          <h4>3、请问在哪里可以查看到此次校园招聘的最新动态？</h4>
          <p>最新动态信息请关注官方微信公众号（南方报业校园招聘）、南方+客户端南方号（南方报业招聘）、官方微信服务号（南方报业招聘）、新浪官方微博（@南方报业校园招聘），若有任何进展，将及时更新发布。</p>
        </Box> */}
      </Box>
    </Box>
  )
}

export default HelpPage
